import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client'
import ModifiersSubTab from './ModifiersSubTab'
import ModifierGroupsSubTab from './ModifierGroupsSubTab'
import OptionGroupsSubTab from './OptionGroupsSubTab'
import {
  GET_ADVANCED_MODIFIERS,
  GET_ADVANCED_MODIFIER_GROUPS,
  GET_ADVANCED_OPTION_GROUPS,
} from '../apollo/advancedMenuQueries'
import { mw, tabsSx, countPillSx } from './menuWorkspaceStyles'

const AdvancedModifierStudio = () => {
  const { t } = useTranslation()
  const [subTab, setSubTab] = useState(0)
  const restaurantId = localStorage.getItem('restaurantId')

  const { data: modData } = useQuery(GET_ADVANCED_MODIFIERS, {
    variables: { restaurantId },
    skip: !restaurantId,
    fetchPolicy: 'cache-and-network'
  })

  const { data: groupData } = useQuery(GET_ADVANCED_MODIFIER_GROUPS, {
    variables: { restaurantId },
    skip: !restaurantId,
    fetchPolicy: 'cache-and-network'
  })

  const { data: optData } = useQuery(GET_ADVANCED_OPTION_GROUPS, {
    variables: { restaurantId },
    skip: !restaurantId,
    fetchPolicy: 'cache-and-network'
  })

  const modCount = modData?.advancedModifiers?.length ?? ''
  const groupCount = groupData?.advancedModifierGroups?.length ?? ''
  const optCount = optData?.advancedOptionGroups?.length ?? ''

  // The count renders as a pill (orange-tinted on the active tab, via the
  // .Mui-selected rule on the Tabs sx below).
  const tabLabel = (name, count) =>
    count !== '' ? (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
        {t(name)}
        <Box component="span" className="mw-count">{count}</Box>
      </Box>
    ) : t(name)

  return (
    <Box>
      <Box sx={{ borderBottom: `1px solid ${mw.color.border}`, mb: 3.5 }}>
        <Tabs value={subTab} onChange={(e, v) => setSubTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{
          ...tabsSx,
          '& .mw-count': countPillSx(false),
          '& .Mui-selected .mw-count': { bgcolor: mw.color.accentSoft, color: mw.color.accent },
        }}>
          <Tab label={tabLabel('Modifiers', modCount)} />
          <Tab label={tabLabel('Modifier Groups', groupCount)} />
          <Tab label={tabLabel('Option Groups', optCount)} />
        </Tabs>
      </Box>

      {subTab === 0 && <ModifiersSubTab />}
      {subTab === 1 && <ModifierGroupsSubTab />}
      {subTab === 2 && <OptionGroupsSubTab />}
    </Box>
  )
}

export default AdvancedModifierStudio
